const DATA_SYNC_EVENT = 'tauris:data-sync';
let syncVersion = 0;

export function triggerDataSync(reason = 'update', collection = null) {
    syncVersion += 1;
    if (typeof window !== 'undefined') {
        window.dispatchEvent(
            new CustomEvent(DATA_SYNC_EVENT, {
                detail: {
                    version: syncVersion,
                    reason,
                    collection,
                    at: Date.now(),
                },
            })
        );
    }
}

export function subscribeToDataSync(handler) {
    if (typeof window === 'undefined' || typeof handler !== 'function') {
        return () => {};
    }
    const wrapped = (event) => handler(event?.detail || null);
    window.addEventListener(DATA_SYNC_EVENT, wrapped);
    return () => window.removeEventListener(DATA_SYNC_EVENT, wrapped);
}

export function getDataSyncVersion() {
    return syncVersion;
}
